// extracted by mini-css-extract-plugin
export default {"Container":"IFSliderPicker_Container__IiWbH","Text":"IFSliderPicker_Text__MTi28","PopperContainer":"IFSliderPicker_PopperContainer__o37I3","Slider":"IFSliderPicker_Slider__sEdOE"};